import React from 'react'

interface MoveIconProps {
    className?: string
    color?: string
}

const MoveIcon: React.FC<MoveIconProps> = ({ className, color = '#147BC2' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        className={className}
    >
        <g clipPath="url(#clip0_18110_6512)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.6563 4V11.0003H10.6841V4.99973H6.79977V0.999725H0.971091V15.0003H8.74195V16H0V0H7.77086L11.6563 4ZM7.77086 4H10.2818L7.77086 1.4139V4Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.5853 10.6095L15.8938 12.986C16.0354 13.1319 16.0354 13.3683 15.8938 13.5141L13.5853 15.8906C13.4437 16.0365 13.214 16.0365 13.0724 15.8906C12.9307 15.7448 12.9307 15.5083 13.0724 15.3625L14.7616 13.6235H9.83354C9.6332 13.6235 9.4708 13.4563 9.4708 13.2501C9.4708 13.0438 9.6332 12.8767 9.83354 12.8767H14.7616L13.0724 11.1376C12.9307 10.9918 12.9307 10.7554 13.0724 10.6095C13.214 10.4637 13.4437 10.4637 13.5853 10.6095Z"
                fill={color}
            />
        </g>
        <defs>
            <clipPath id="clip0_18110_6512">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
)

export default MoveIcon
